import { render } from "./EasyDigestDetails.vue?vue&type=template&id=07d8f702"
import script from "./EasyDigestDetails.vue?vue&type=script&lang=js"
export * from "./EasyDigestDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__